import { CSSProperties, FC, FormEvent, useCallback } from "react";
import { observer } from "mobx-react-lite";
import "./Search.css";
import SearchElem from "../../../assets/search.svg";
import Cross from "../../../assets/cancelGreey.svg";
import "../../buttons/DefaultButtons.css";

export interface ISearchComponentProps {
    value: string;
    placeholder?: string;
    onSubmitFunc?: (value: string) => void;
    changeSearchValue?: (value: string) => void;
    onClick?: () => void;
    hideSubmitButton?: boolean;
    showPreviewList?: boolean;
    className?: string;
    style?: CSSProperties;
    showResetButton?: boolean;
    onReset?: () => void;
}

const Search: FC<ISearchComponentProps> = observer(({
    value,
    placeholder = "Поиск...",
    onSubmitFunc,
    changeSearchValue,
    hideSubmitButton,
    showPreviewList,
    showResetButton,
    onReset,
    className = "",
    style,
    onClick
}) => {
    const handleSubmit = useCallback((event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (onSubmitFunc) {
            const formData = new FormData(event.currentTarget);
            const searchValue = formData.get("search") as string;
            onSubmitFunc(searchValue);
        }
    }, [onSubmitFunc]);

    const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        changeSearchValue?.(e.target.value);
    }, [changeSearchValue]);

    const handleResetClick = useCallback((e: React.MouseEvent) => {
        e.stopPropagation();
        onReset?.();
    }, [onReset]);

    const handleInputClick = useCallback((e: React.MouseEvent<HTMLInputElement>) => {
        onClick?.();
    }, [onClick]);

    const handleFormClick = useCallback((e: React.MouseEvent<HTMLFormElement>) => {
        e.stopPropagation();
    }, []);

    return (
        <div style={style} className={`custom_search ${className}`}>
            <div style={{ width: "100%" }}>
                <form
                    onSubmit={handleSubmit}
                    className="custom_search-form"
                    onClick={handleFormClick}
                >
                    <input
                        name="search"
                        onClick={handleInputClick}
                        placeholder={placeholder}
                        onChange={handleInputChange}
                        type="search"
                        value={value}
                    />

                    {showResetButton && (
                        <img
                            src={Cross}
                            alt="Очистить поиск"
                            onClick={handleResetClick}
                            className="search-reset-button"
                        />
                    )}

                    {!hideSubmitButton && (
                        <button type="submit" className="button-base">
                            <img src={SearchElem} alt="Найти" />
                        </button>
                    )}
                </form>
            </div>

            {showPreviewList && <div className="search-preview-list"></div>}
        </div>
    );
});

export default Search;